// extracted by mini-css-extract-plugin
export default {"link":"xpknbTjYphkUt6fU2W0m"};